import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'flowbite-react';
import { HiHome } from 'react-icons/hi';

export default function Breadcrumbs({ currentApp }) {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  const getBreadcrumbs = () => {
    const items = [];
    
    // Всегда добавляем корень
    items.push({
      to: '/apps',
      label: 'Приложения',
      icon: HiHome
    });
    
    if (pathSegments.length === 0) {
      return items;
    }
    
    // Разные сценарии маршрутов
    if (pathSegments[0] === 'apps') {
      if (pathSegments[1] === 'new') {
        items.push({
          label: 'Новое приложение',
          current: true
        });
      }
      // других маршрутов вида /apps/:id не существует — игнорируем
    } else if (pathSegments[0] && currentApp) {
      // Маршруты приложения по UUID: /:appUuid/*
      items.push({
        to: `/${currentApp.id}/dashboard`,
        label: currentApp.name
      });
      
      switch (pathSegments[1]) {
        case 'dashboard':
          items.push({ label: 'Обзор', current: true });
          break;
        case 'users':
          items.push({ label: 'Пользователи', current: true });
          break;
        case 'properties':
          items.push({ label: 'Объекты', current: true });
          break;
        case 'broadcasts':
          items.push({ label: 'Рассылки', current: true });
          break;
        case 'settings':
          items.push({ label: 'Настройки', current: true });
          break;
        case 'bot':
          items.push({ label: 'Чат-бот', current: true });
          break;
        default:
          break;
      }
    } else if (pathSegments[0] === 'users' && pathSegments[1]) {
      items.push({
        label: 'Пользователь',
        current: true
      });
    }
    
    return items;
  };
  
  const breadcrumbs = getBreadcrumbs();
  
  if (breadcrumbs.length <= 1) {
    return null;
  }
  
  return (
    <Breadcrumb aria-label="Breadcrumb" className="mb-4">
      {breadcrumbs.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          icon={index === 0 ? item.icon : undefined}
        >
          {item.current || !item.to ? (
            <span className="text-gray-500">{item.label}</span>
          ) : (
            <Link to={item.to} className="underline underline-offset-2 decoration-blue-500 hover:text-blue-700">
              {item.label}
            </Link>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}